export const encodePhrase = (text) => {
    const base64 = btoa(unescape(encodeURIComponent(text)));
    // base64url: replace +/ with -_, remove padding =
    return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};

export const decodePhrase = (encoded) => {
    try {
        // Restore standard base64 from base64url
        let base64 = encoded.replace(/-/g, '+').replace(/_/g, '/');
        // Restore padding
        while (base64.length % 4) base64 += '=';
        return decodeURIComponent(escape(atob(base64)));
    } catch {
        return null;
    }
};

export const getPhraseFromURL = () => {
    const params = new URLSearchParams(window.location.search);
    const p = params.get('p');
    return p ? decodePhrase(p) : null;
};

export const buildShareURL = (text) => {
    return `${window.location.origin}${window.location.pathname}?p=${encodePhrase(text)}`;
};
